module.exports = __webpack_public_path__ + "img/hallazgos.ff1f0102.svg";